import "@babel/polyfill";
import 'url-search-params-polyfill';
import './helpers/polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Pages from './Pages';
import * as serviceWorker from './serviceWorker';


// Add this:
var _wr = function(type) {
	var orig = window.history[type];
	return function() {
		var rv = orig.apply(this, arguments);
		var e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
window.history.pushState = _wr('pushState');
window.history.replaceState = _wr('replaceState');


if(window.Drupal.runningDrupal) {
  (function(Drupal) {
    Drupal.behaviors.app = {
      attach: function(context, settings) {
        const userIsAnonymous = (settings.productSearch && typeof settings.productSearch.userIsAnonymous !== 'undefined') ? settings.productSearch.userIsAnonymous : true;
        const language = (settings.productSearch && settings.productSearch.language) ? settings.productSearch.language : "en";
        const esApp = (settings.productSearch && settings.productSearch.esApp) ? settings.productSearch.esApp : 'elasticsearch_index_tech_insights_products';
        const esUrl = (settings.productSearch && settings.productSearch.esUrl) ? settings.productSearch.esUrl : 'http://127.0.0.1:9200';
        const searchType = (settings.productSearch && settings.productSearch.searchType) ? settings.productSearch.searchType : 'products';

        if(searchType === 'pages') {
          ReactDOM.render(<Pages language={language} esApp={esApp} esUrl={esUrl} />, document.getElementById('product-search-app'));
        } else {
          const subscriptionTypes = (settings.productSearch && settings.productSearch.subscriptionTypes) ? settings.productSearch.subscriptionTypes : [];
          ReactDOM.render(<App userIsAnonymous={userIsAnonymous} language={language} esApp={esApp} esUrl={esUrl} help={settings.productSearch.searchHelp} subscriptionTypes={subscriptionTypes} />, document.getElementById('product-search-app'));
        }
      }
    }
  })(window.Drupal);
} else {
  //app="elasticsearch_index_ti_products"
  //url="https://ti-elastic.76design.com"
  const language = "en";
  const esUrl = 'http://127.0.0.1:9200';
  const searchType = 'products';
  const userIsAnonymous = true;

  if(searchType === 'pages') {
    const esApp = 'elasticsearch_index_tech_insights_pages';
    ReactDOM.render(<Pages language={language} esApp={esApp} esUrl={esUrl} />, document.getElementById('product-search-app'));
  } else {
    const esApp = 'elasticsearch_index_tech_insights_products';
    const subscriptionTypes = ['IoT', 'Logic', 'Teardown'];
    ReactDOM.render(<App userIsAnonymous={userIsAnonymous} language={language} esApp={esApp} esUrl={esUrl} help="" subscriptionTypes={subscriptionTypes} />, document.getElementById('product-search-app'));
  }
}

//ReactDOM.render(<App />, document.getElementById('product-search-app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
